<list-view *ngIf="liste" [liste]="liste"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
